<template>
  <div>
    <modal
      width="700"
      :name="'removeStudent'"
      :adaptive="true"
      :scrollable="true"
      :height="'auto'"
      class="modal-remove-student"
    >
      <div class="__wrapper">
        <div v-if="item">
          <h4>{{ item.full_name }}</h4>
        </div>
        <div class="row">
          <div class="col-6 m-y-2">
            Учебный год выбытия
            <select v-model="school_transferred_to" class="form-control">
              <option v-for="(option, key) in seasons" :key="key" :value="option.id">
                {{ option.title }}
              </option>
            </select>
          </div>
          <div class="col-6 m-y-2">
            Куда выбыл
            <input type="text" class="form-control" v-model="region_transferred_to">
          </div>
          <div class="col-6 m-y-2">
            Дата приказа о выбытии
            <input type="date" class="form-control" v-model="exclusion_order_date">
          </div>
          <div class="col-6 m-y-2">
            Номер приказа (если есть)
            <input type="text" class="form-control" v-model="exclusion_order_number">
          </div>
        </div>
        <div class="ta-center m-t-10 btn-content">
          <span class="btn-def" >
            <button class="p-x-8" @click="handle">Исключить</button>
          </span>
        </div>
      </div>
    </modal>
        <list 
          ref="listComp"
          :columns="columns" 
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :openItem="false"
          :fields="fields"
          :fieldClass="'col-md-6'"
          :searchDisable="true"
          :removeModal="removeModal"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val" 
        >
        <template v-slot:tableTabs>
          <tabs :tabs="tabsTable" @input="tabClick" :active="activeTabsTable" v-model="activeTabsTable" style="z-index: 19;"/>
          <template v-for="(tab, key) in tabsTable">
            <div v-if="activeTabsTable === key" :key="key"></div>
          </template>
        </template>
        </list>
      
    
    </list>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { toFormData } from "@/_api/_helper";
export default {
  name: "products",
  props: ['id'],
  created() {
    // this.itemLink = `business/groups/${this.id}/clients`;
    let bid = this.$store.state.business.id
    this.itemLink = `${process.env.HOST_URL}/api/v3/schools/${bid}/classes/${this.id}/students`;
    this.setLink = `${process.env.HOST_URL}/api/v3/schools/${bid}/classes/${this.id}/students`;

    this.school_from = localStorage.getItem("seasonId");
    
  },
  methods: {
    tabClick(p){
      let tab = this.tabsTable[p]
      if(tab.columns.length)
        this.columns = tab.columns
      if(tab.itemLink)
        this.itemLink = tab.itemLink
      setTimeout(() => {
        this.$refs.listComp.getList()  
      }, 1);
    },
    handle(){
      let fileds = {};
      fileds["school_transferred_to"] = this.school_transferred_to;
      fileds["region_transferred_to"] = this.region_transferred_to;
      fileds["exclusion_order_date"] = this.exclusion_order_date;
      fileds["exclusion_order_number"] = this.exclusion_order_number;
      let bid = this.$store.state.business.id
      console.log('id', this.id, this.item)
      this.$loading(true);
      this.$http
        .post(`${process.env.HOST_URL}/api/v3/schools/${bid}/classes/${this.id}/students/${this.item.id}/drop-out`, toFormData(fileds))
        .then((response) => {
          this.$modal.hide('removeStudent')
          this.school_transferred_to = null
          this.region_transferred_to = null
          this.exclusion_order_date = null
          this.exclusion_order_number = null
          // this.$notify({
          //   title: this.$store.state.text["success"],
          //   message: this.$store.state.text["data_changed"],
          //   icon: "ti-save",
          //   horizontalAlign: "right",
          //   verticalAlign: "top",
          //   type: "success",
          // });

          // this.$store.dispatch("setUser", response.data.data);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    removeModal(item){
      this.item = item
      this.$modal.show('removeStudent')
    },
    changeFunction(val) { },
    change(val) { },

  },
  computed:{
    ...mapState(["seasons"]),
  },
  mounted(){
    this.tabClick(0)
  },
  data() {
    return {
      val: [],
      item: null,
      activeTabsTable: 0,
      school_transferred_to: null,
      region_transferred_to: null,
      exclusion_order_date: null,
      exclusion_order_number: null,
      modalCreate: "course_group",
      tabsTable: [
        {
          title: "Все",
          itemLink: `${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/classes/${this.id}/students`,
          columns: [
            {
              key: "id",
              title: "ID",
              checkbox: false,
              disableLink: true,
            },
            {
              key: "full_name",
              title: "ФИО",
              checkbox: false,
              disableLink: true,
              object: 'position',
            },
            {
              key: "phone",
              title: "Номер телефона",
              checkbox: false,
              control: false,
              align: "left",
              timer: false,
              detail: false,
            },
            {
              key: "group",
              title: "Зачислен",
              checkbox: false,
              disableLink: true,
              dateTimeFormat: true,
              object: 'join_at',
            },
            {
              key: "group",
              title: "Выбыл",
              checkbox: false,
              disableLink: true,
              dateTimeFormat: true,
              object: 'left_at',
            },
            {
              detail: true,
              remove: true,
              removeStudent: true,
            },
          ],
        },
        {
          title: "Прибывшие",
          itemLink: `${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/classes/${this.id}/students`,
          columns: [
            {
              key: "id",
              title: "ID",
              checkbox: false,
              disableLink: true,
            },
            {
              key: "full_name",
              title: "ФИО",
              checkbox: false,
              disableLink: true,
              object: 'position',
            },
            {
              key: "phone",
              title: "Номер телефона",
              checkbox: false,
              control: false,
              align: "left",
              timer: false,
              detail: false,
            },
            {
              key: "admission",
              title: "Учебный год прибытия",
              disableLink: true,
              object: "school_from",
            },
            {
              key: "admission",
              title: "Откуда прибыл",
              disableLink: true,
              object: "region_from",
            },
            {
              key: "admission",
              title: "Дата приказа о зачислении",
              disableLink: true,
              dateTimeFormat: true,
              object: "admission_order_date",
            },
            {
              key: "admission",
              title: "Номер приказа",
              disableLink: true,
              object: "admission_order_number",
            },
            {
              key: "group",
              title: "Зачислен",
              checkbox: false,
              disableLink: true,
              dateTimeFormat: true,
              object: 'join_at',
            },
            {
              key: "group",
              title: "Выбыл",
              checkbox: false,
              disableLink: true,
              dateTimeFormat: true,
              object: 'left_at',
            },
            {
              detail: true,
              removeStudent: true,
            },
          ]
        },
        {
          title: "Выбывшие",
          itemLink: `${process.env.HOST_URL}/api/v3/schools/${this.$store.state.business.id}/classes/${this.id}/students/list-dropped-out`,
          columns: [
            {
              key: "id",
              title: "ID",
              checkbox: false,
              disableLink: true,
            },
            {
              key: "full_name",
              title: "ФИО",
              checkbox: false,
              disableLink: true,
              object: 'position',
            },
            {
              key: "phone",
              title: "Номер телефона",
              checkbox: false,
              control: false,
              align: "left",
              timer: false,
              detail: false,
            },
            {
              key: "exclusion",
              title: "Класс",
              disableLink: true,
              object: "class_id",
            },
            {
              key: "exclusion",
              title: "Учебный год выбытия",
              disableLink: true,
              object: "school_transferred_to",
            },
            {
              key: "exclusion",
              title: "Откуда прибыл",
              disableLink: true,
              object: "region_transferred_to",
            },
            {
              key: "exclusion",
              title: "Дата приказа о зачислении",
              disableLink: true,
              dateTimeFormat: true,
              object: "exclusion_order_date",
            },
            {
              key: "exclusion",
              title: "Номер приказа",
              disableLink: true,
              object: "exclusion_order_number",
            },
            {
              detail: true,
              // removeStudent: true,
            },
          ]
        },
      ],
      fields: [
        {
          col: 'col-12 col-md-12',
          label: "Выберите ученика",
          key: "student",
          type: "select",
          selectKey: "full_name",
          modal: "client",
          prefix: "group_client",
        },
        {
          col: "col-12 col-md-6",
          key: "school_from",
          label: "Учебный год прибытия",
          // type: "seasonField",
          type: "field",
          textType: "text",
        },
        {
          col: "col-12 col-md-6",
          key: "region_from",
          label: "Откуда прибыл",
          type: "field",
          textType: "text",
        },
        {
          col: "col-12 col-md-6",
          label: "Дата приказа о зачислении",
          key: "admission_order_date",
          type: "date",
        },
        {
          col: "col-12 col-md-6",
          key: "admission_order_number",
          label: "Номер приказа",
          type: "field",
          textType: "text",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_client",
      itemLink: "",
      setLink: "",
      columns: []
    };
  },
};
</script>
<style lang="scss">
  .modal-remove-student{
    .__wrapper{
      border-radius: 20px;
      background-color: white;
      padding: 35px 35px;
    }
  }
</style>
